export default __webpack_public_path__ + "static/media/svg3.43d48b01.svg";